import React, { useMemo } from 'react';
import DNABox from "../DNABox/DNABox";
import Stack from "../Stack/Stack";
import DNAText from "../../type/DNAText/DNAText";
import styled from "../../../theming/util/styled";
export var DNAHeaderAppearanceEnum;
(function (DNAHeaderAppearanceEnum) {
    DNAHeaderAppearanceEnum["basic"] = "basic";
})(DNAHeaderAppearanceEnum || (DNAHeaderAppearanceEnum = {}));
export const DNAHeaderAppearanceKeys = Object.keys(DNAHeaderAppearanceEnum);
export var DNAHeaderStatusEnum;
(function (DNAHeaderStatusEnum) {
    DNAHeaderStatusEnum["neutral"] = "neutral";
    DNAHeaderStatusEnum["brand"] = "brand";
    DNAHeaderStatusEnum["flat"] = "flat";
})(DNAHeaderStatusEnum || (DNAHeaderStatusEnum = {}));
export var DNAHeaderSizeEnum;
(function (DNAHeaderSizeEnum) {
    DNAHeaderSizeEnum["small"] = "small";
    DNAHeaderSizeEnum["medium"] = "medium";
})(DNAHeaderSizeEnum || (DNAHeaderSizeEnum = {}));
export const DNAHeaderStatusKeys = Object.keys(DNAHeaderStatusEnum);
export const DNAHeaderSizeKeys = Object.keys(DNAHeaderSizeEnum);
const parseComponentStyle = (source) => {
    const { textProps, ...rest } = source;
    return {
        containerStyle: rest,
        textProps,
    };
};
const DNAHeader = (props) => {
    const { eva, title, children, testID, style } = props;
    const { containerStyle, textProps } = parseComponentStyle(eva.style);
    const [Left, Center, Right] = useMemo(() => {
        return React.Children
            .toArray(children)
            .reduce((acc, child) => {
            if (React.isValidElement(child)) {
                // @ts-expect-error
                const displayName = child.type?.displayName;
                if (displayName === DNAHeaderLeft.displayName) {
                    acc[0] = child;
                }
                else if (displayName === DNAHeaderCenter.displayName) {
                    acc[1] = child;
                }
                else if (displayName === DNAHeaderRight.displayName) {
                    acc[2] = child;
                }
            }
            return acc;
        }, []);
    }, [children]);
    return (<DNABox alignX="center" alignY="center" style={{ ...containerStyle, ...style }} testID={testID}>
      <Stack anchor="center">
        {/* Guiding Layer */}
        <Stack.Layer>
          <DNABox fill/>
        </Stack.Layer>

        {/* LEFT SIDE */}
        <Stack.Layer anchor="left" {...Left?.props}>
          {Left}
        </Stack.Layer>

        {/* TITLE OR CENTER CONTENT(TODO?) */}
        <Stack.Layer anchor="center" {...Center?.props}>
          {title
            ? <DNAText testID="page-title" {...textProps} numberOfLines={1}>
                {title}
              </DNAText>
            : Center}
        </Stack.Layer>

        {/* RIGHT SIDE */}
        <Stack.Layer anchor="right" {...Right?.props}>
          {Right}
        </Stack.Layer>
      </Stack>
    </DNABox>);
};
const DNAHeaderLeft = (props) => props.children;
const DNAHeaderCenter = (props) => props.children;
const DNAHeaderRight = (props) => props.children;
// TODO: Consider a DNAHeaderFill?
DNAHeaderLeft.displayName = 'DNAHeaderLeft';
DNAHeaderCenter.displayName = 'DNAHeaderCenter';
DNAHeaderRight.displayName = 'DNAHeaderRight';
const DNAHeaderStyled = styled('DNAHeader')(DNAHeader);
DNAHeaderStyled.Left = DNAHeaderLeft;
DNAHeaderStyled.Center = DNAHeaderCenter;
DNAHeaderStyled.Right = DNAHeaderRight;
export default DNAHeaderStyled;
//# sourceMappingURL=DNAHeader.js.map